module.exports = __webpack_public_path__ + "img/LOGO.2d2a0ea3.png";